import type { Quest } from '../../../shared/kernel/types';

export const INITIAL_QUESTS: Quest[] = [
  {
    id: 'quest_first_steps',
    title: '생명의 시작 (Genesis)',
    description: '테라리움 시뮬레이션을 20초 이상 안정적으로 지속하세요.',
    category: 'balance',
    rewardTitle: '신비의 보라 유리병 스킨 해금',
    completed: false,
    progress: 0,
    maxProgress: 20,
    check: (stats) => stats.simulationAgeSeconds >= 20,
  },
  {
    id: 'quest_trio_balance',
    title: '삼총사의 균형 (Trophic Trio)',
    description: '생산자, 1차 소비자, 분해자가 각각 3마리 이상 동시에 생존하도록 유지하세요.',
    category: 'balance',
    rewardTitle: '다이아몬드 지오메트릭 돔 해금',
    completed: false,
    progress: 0,
    maxProgress: 3,
    check: (stats) =>
      stats.producerCount >= 3 && stats.herbivoreCount >= 3 && stats.decomposerCount >= 3,
  },
  {
    id: 'quest_apex_predator',
    title: '최상위 포식자의 군림 (Apex Dominance)',
    description: '포식자를 포함하여 4단계 트로픽 레벨 모두 공존하는 생태계를 완성하세요.',
    category: 'balance',
    rewardTitle: '심해 산호 모래 바닥재 해금',
    completed: false,
    progress: 0,
    maxProgress: 4,
    check: (stats) =>
      stats.producerCount >= 2 && stats.herbivoreCount >= 2 && stats.predatorCount >= 1 && stats.decomposerCount >= 1,
  },
  {
    id: 'quest_solar_evolution',
    title: '태양의 축복 (Solar Blessing)',
    description: '일조량을 80% 이상으로 올려 새로운 식물 변종(솔라 블룸)을 탄생시키세요.',
    category: 'evolution',
    rewardTitle: '석양의 창가 배경 테마 해금',
    completed: false,
    progress: 0,
    maxProgress: 1,
    check: (stats, env) => env.sunlight >= 80 && stats.unlockedSpeciesCount >= 5,
  },
  {
    id: 'quest_ice_age',
    title: '빙하기의 생존자 (Ice Age Survivor)',
    description: '온도를 5°C 이하로 낮춰 저온 내성종(크리스탈 리프)을 적응시키세요.',
    category: 'environment',
    rewardTitle: '수정 동굴 바닥재 해금',
    completed: false,
    progress: 0,
    maxProgress: 1,
    check: (stats, env) => env.temperature <= 5 && stats.unlockedSpeciesCount >= 6,
  },
  {
    id: 'quest_mutagen_catalyst',
    title: '유전 돌연변이 촉진 (Mutagen Burst)',
    description: '돌연변이 촉매제를 주입하여 3세대 이상의 자손을 번식시키세요.',
    category: 'evolution',
    rewardTitle: '특수 에테르 스포어 포자 해금',
    completed: false,
    progress: 0,
    maxProgress: 3,
    check: (stats) => stats.generationRecord >= 3,
  },
  {
    id: 'quest_biodiversity_master',
    title: '다양성의 오아시스 (Biodiversity Oasis)',
    description: '생물 다양성 섀넌 지수(Shannon Index) 1.5 이상을 달성하세요.',
    category: 'balance',
    rewardTitle: '새벽 안개 숲 배경 해금',
    completed: false,
    progress: 0,
    maxProgress: 15,
    check: (stats) => stats.biodiversityIndex >= 1.5,
  },
  {
    id: 'quest_night_whisper',
    title: '밤의 생체 발광 (Bioluminescent Night)',
    description: '야간 시간대에 생체 발광을 뿜어내는 생물 15마리 이상을 관찰하세요.',
    category: 'sound',
    rewardTitle: '오로라 우주 배경 테마 해금',
    completed: false,
    progress: 0,
    maxProgress: 15,
    check: (stats, env) =>
      env.dayNightCycle > 0.4 && env.dayNightCycle < 0.9 && stats.totalOrganisms >= 15,
  },
  {
    id: 'quest_harmony_maestro',
    title: '생태계 지휘자 (Ecosystem Maestro)',
    description: '바이오 하모니 지수(Harmony Score) 750점 이상을 달성하여 화음 심포니를 울리세요.',
    category: 'sound',
    rewardTitle: '마법 수정구 돔 스킨 해금',
    completed: false,
    progress: 0,
    maxProgress: 750,
    check: (stats) => stats.bioHarmonyScore >= 750,
  },
  {
    id: 'quest_encyclopedia_collector',
    title: '위대한 생물학자 (Grand Naturalist)',
    description: '생물 도감에서 8종 이상의 신종 생물을 해금하세요.',
    category: 'evolution',
    rewardTitle: '전설의 코스믹 플랑크톤 유인 시약 해금',
    completed: false,
    progress: 0,
    maxProgress: 8,
    check: (stats) => stats.unlockedSpeciesCount >= 8,
  },
];
